import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
// import dayjs from "dayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import "./date-input.scss";

/* eslint-disable-next-line */
export interface DateInputProps {
  //react-hook-form props
  field: any;
  register?: any;
  getFieldState?: any;
  formState?: any;
  errors?: any;
  //input props
  name: string;
  value?: Date;
  label?: string;
  placeholder?: string;
  assistiveText?: string;
  iconButton?: string;
  actionIconButton?: () => void;
  required?: boolean;
  validationIcons?: boolean;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  hiddenDay?: boolean;
}

export function DateInput(props: DateInputProps) {
  const { isDirty, isTouched } = props.getFieldState(
    props.field.name,
    props.field.formState
  );
  const [date, setDate] = useState<Date | null>(
    props.value ? props.value : null
  );

  useEffect(() => {
    if (date !== props.value && !props.value) {
      setDate(null);
    } else if (date !== props.value && props.value) {
      setDate(props.value);
    }
  }, [props.value]);

  return (
    <div className="date-container">
      {/* {props.label && (
        <label
          className={`input-date-label ${props.disabled && "disabled"} ${
            isDirty || isTouched || props.value ? "filled" : ""
          }`}
        >
          {props.label} {props.required && <span>*</span>}
        </label>
      )} */}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker"]}>
          <DatePicker
            format="DD/MM/YYYY"
            value={date ? dayjs(date) : null}
            label={props.label}
            // onFocus={(e: any) => {
            //   e.target.placeholder = props.placeholder ? props.placeholder : "";
            // }}
            // {...props.register(props.name)}
            onChange={(newValue) => {
              const date = newValue ? newValue.toDate() : null;
              props.field.onChange(date);
              setDate(date);

              // (date: Date) => {
              // props.field.onChange(date);
              // setDate(date);
            }}
            maxDate={props.maxDate ? dayjs(props.maxDate) : undefined}
            disabled={props.disabled}
            views={
              props.hiddenDay ? ["month", "year"] : ["day", "month", "year"]
            }
          />
        </DemoContainer>
      </LocalizationProvider>
      {props.assistiveText && (
        <p className="assistive-text">{props.assistiveText}</p>
      )}
      {props.errors &&
        props.errors[props.name] &&
        !props.iconButton &&
        props.validationIcons && (
          <i className="bi bi-exclamation-triangle-fill icon-error"></i>
        )}
      {props.errors && props.errors[props.name] && (
        <p className="error">{props.errors[props.name]?.message?.toString()}</p>
      )}
      {props.errors &&
        !props.errors[props.name] &&
        isDirty &&
        !props.iconButton &&
        props.validationIcons && (
          <i className="bi bi-check-lg icon-success"></i>
        )}
    </div>
  );
}

export default DateInput;
